import { put, select } from "redux-saga/effects";

import { apiFetch } from "common/utilities";
import { getTmSelectedOuterNodeId } from "domains/transformationMap/selectors";
import type { KnowledgeResponse } from "entities/knowledge/types";
import { fetchKnowledgeFeedForTopicFailure, fetchKnowledgeFeedForTopicSuccess } from "entities/knowledgeFeed/actions";
import type { KnowledgeFeedFetchForTopicAction } from "entities/knowledgeFeed/actionTypes";
import { getLatestFetchParams } from "entities/knowledgeFeed/sagas/utils";

export function* fetchKnowledgeFeedForTopicSaga(action: KnowledgeFeedFetchForTopicAction) {
  const { id } = action.payload;
  try {
    const secondaryTopicId: ReturnType<typeof getTmSelectedOuterNodeId> = yield select(getTmSelectedOuterNodeId);
    const searchCriteria = { ...action.payload, secondaryTopicId };
    const queryParams = getLatestFetchParams(searchCriteria);
    const payload: KnowledgeResponse[] = yield apiFetch(`topic/${id}/knowledge_feed`, { queryParams });

    yield put(fetchKnowledgeFeedForTopicSuccess({ topicId: id, data: payload }, searchCriteria));
  } catch {
    yield put(fetchKnowledgeFeedForTopicFailure({ logoutOnAuthError: true, searchCriteria: action.payload }));
  }
}
